import type { CollectibleSpawnPoint } from '../level/segments/SegmentDefinition';
import type { SegmentInstance } from '../level/segments/SegmentInstance';
import { aabbFromCenterSize, type Aabb } from '../physics/Aabb';
import type { Vec3 } from '../utils/math';
import type { CollectibleDefinition } from './CollectibleDefinition';

export class CollectibleInstance {
  collected = false;
  /** Segment-local base position (spawn point + height offset). */
  readonly localPosition: Vec3;
  readonly trackCollider: Aabb;

  constructor(
    readonly uid: number,
    readonly definition: CollectibleDefinition,
    readonly segment: SegmentInstance,
    readonly spawnPoint: CollectibleSpawnPoint,
    heightOffset: number,
    /** Size factor of visual and pickup volume (set-piece rewards like the big golden bottle). */
    readonly scale = 1,
  ) {
    this.localPosition = { x: spawnPoint.position.x, y: spawnPoint.position.y + heightOffset, z: spawnPoint.position.z };
    const origin = segment.localToTrack(this.localPosition);
    const c = definition.collider;
    this.trackCollider = aabbFromCenterSize(
      { x: origin.x + c.center.x * scale, y: origin.y + c.center.y * scale, z: origin.z + c.center.z * scale },
      { x: c.size.x * scale, y: c.size.y * scale, z: c.size.z * scale },
    );
  }
}
